import axios from "axios";

const baseURL = process.env.REACT_APP_BASE_ADMIN_API_URL || process.env.REACT_APP_BASE_API_URL;

const client = axios.create({ baseURL });

client.interceptors.request.use(async (config) => {
  // Attach the platform JWT from localStorage like the global axios instance
  const token = localStorage.getItem("access_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  // Ensure no tenant BU header contaminates admin calls
  if (config.headers["X-Business-Unit-Id"]) {
    delete config.headers["X-Business-Unit-Id"];
  }
  return config;
});

export const saApi = {
  // Companies
  listCompanies: (params) => client.get("/admin/companies", { params }).then(r => r.data),
  getCompany: (companyId) => client.get(`/admin/companies/${companyId}`).then(r => r.data),
  createCompany: (payload) => client.post("/admin/companies", payload).then(r => r.data),
  updateCompany: (companyId, payload) => client.patch(`/admin/companies/${companyId}`, payload).then(r => r.data),
  deleteCompany: (companyId) => client.delete(`/admin/companies/${companyId}`).then(r => r.data),
  // Pilot licenses
  getCompanyPilotLicenses: (companyId) => client.get(`/admin/companies/${companyId}/licenses/pilot`).then(r => r.data),
  assignCompanyPilotLicense: (companyId, userId) => client.post(`/admin/companies/${companyId}/licenses/pilot/assign`, { user_id: userId }).then(r => r.data),
  unassignCompanyPilotLicense: (companyId, userId) => client.post(`/admin/companies/${companyId}/licenses/pilot/unassign`, { user_id: userId }).then(r => r.data),
  getCompanyPilotLicenseHistory: (companyId, params) => client.get(`/admin/companies/${companyId}/licenses/pilot/history`, { params }).then(r => r.data),
  // ASAP PROFILE / PDL safeguards (per-company budget + load-more cap)
  getCompanyPdlLimits: (companyId) => client.get(`/admin/companies/${companyId}/pdl-limits`).then(r => r.data),
  updateCompanyPdlLimits: (companyId, payload) => client.patch(`/admin/companies/${companyId}/pdl-limits`, payload).then(r => r.data),
  // Company business units
  listCompanyBusinessUnits: (companyId) => client.get(`/admin/companies/${companyId}/business-units`).then(r => r.data),
  createCompanyBusinessUnit: (companyId, payload) => client.post(`/admin/companies/${companyId}/business-units`, payload).then(r => r.data),
  updateCompanyBusinessUnit: (companyId, businessUnitId, payload) => client.patch(`/admin/companies/${companyId}/business-units/${businessUnitId}`, payload).then(r => r.data),
  deleteCompanyBusinessUnit: (companyId, businessUnitId) => client.delete(`/admin/companies/${companyId}/business-units/${businessUnitId}`).then(r => r.data),
  // Company users
  listCompanyUsers: (companyId, params) => client.get(`/admin/companies/${companyId}/users`, { params }).then(r => r.data),
  inviteCompanyUser: (companyId, payload) => client.post(`/admin/companies/${companyId}/users/invite`, payload).then(r => r.data),
  updateCompanyUser: (companyId, userId, payload, params) => client.patch(`/admin/companies/${companyId}/users/${userId}`, payload, { params }).then(r => r.data),
  removeUserFromCompany: (companyId, userId) => client.delete(`/admin/companies/${companyId}/users/${userId}`).then(r => r.data),
  removeUserFromBusinessUnit: (companyId, businessUnitId, userId) => client.delete(`/admin/companies/${companyId}/business-units/${businessUnitId}/users/${userId}`).then(r => r.data),
  bulkUpdateUserBUs: (companyId, userId, payload) => client.post(`/admin/companies/${companyId}/users/${userId}/bulk-bu-update`, payload).then(r => r.data),
  // Trial / access
  extendTrial: (companyId, days) => client.post(`/admin/companies/${companyId}/trial/extend`, { days }).then(r => r.data),
  activateCompany: (companyId) => client.post(`/admin/companies/${companyId}/activate`).then(r => r.data),
  deactivateCompany: (companyId) => client.post(`/admin/companies/${companyId}/deactivate`).then(r => r.data),
  // Metrics
  getMetrics: (params) => client.get(`/admin/metrics`, { params }).then(r => r.data),
  // Global users
  listUsers: (params) => client.get(`/admin/users`, { params }).then(r => r.data),
  // Templates
  listTemplates: (params) => client.get(`/admin/templates`, { params }).then(r => r.data),
  uploadTemplate: (formData) => client.post(`/admin/templates`, formData, { headers: { "Content-Type": "multipart/form-data" } }).then(r => r.data),
  deleteTemplate: (templateId) => client.delete(`/admin/templates/${templateId}`).then(r => r.data),
  assignTemplate: (payload) => client.post(`/admin/templates/assign`, payload).then(r => r.data),
};

export default saApi;


